import { Controller } from "remult";

@Controller("communication-record-methods")
export class CommunicationRecordMethods {}
